module.exports = __webpack_public_path__ + "assets/img/pt.155348d0.svg";